module.exports = __webpack_public_path__ + "img/mesa_hl34.ac2dbc61.png";